<template>
    <div class="Colors">
        <div class="Colors__container">
            <span class="Colors__container-title">Primary</span>
            <div class="Colors__row">
                <div
                    v-for="color in primary"
                    :key="color"
                    :class="`Colors__color-block ${color}`"
                />
            </div>
        </div>

        <div class="Colors__container">
            <span class="Colors__container-title">Grayscale</span>
            <div class="Colors__row">
                <div
                    v-for="color in grayscale"
                    :key="color"
                    :class="`Colors__color-block ${color}`"
                />
            </div>
        </div>

        <div class="Colors__container">
            <span class="Colors__container-title">Secondary</span>
            <div class="Colors__row">
                <div
                    v-for="color in secondaryPink"
                    :key="color"
                    :class="`Colors__color-block ${color}`"
                />
            </div>
            <div class="Colors__row">
                <div
                    v-for="color in secondaryPurple"
                    :key="color"
                    :class="`Colors__color-block ${color}`"
                />
            </div>
            <div class="Colors__row">
                <div
                    v-for="color in secondaryTeal"
                    :key="color"
                    :class="`Colors__color-block ${color}`"
                />
            </div>
            <div class="Colors__row">
                <div
                    v-for="color in secondaryOrange"
                    :key="color"
                    :class="`Colors__color-block ${color}`"
                />
            </div>
            <div class="Colors__row">
                <div
                    v-for="color in secondaryBlue"
                    :key="color"
                    :class="`Colors__color-block ${color}`"
                />
            </div>
        </div>

        <div class="Colors__container">
            <span class="Colors__container-title">Semantic</span>
            <div class="Colors__row">
                <div
                    v-for="color in successGreen"
                    :key="color"
                    :class="`Colors__color-block ${color}`"
                />
            </div>
            <div class="Colors__row">
                <div
                    v-for="color in warningYellow"
                    :key="color"
                    :class="`Colors__color-block ${color}`"
                />
            </div>
            <div class="Colors__row">
                <div
                    v-for="color in errorRed"
                    :key="color"
                    :class="`Colors__color-block ${color}`"
                />
            </div>
            <div class="Colors__row">
                <div
                    v-for="color in highlightBlue"
                    :key="color"
                    :class="`Colors__color-block ${color}`"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            primary: [
                'primary-500',
                'primary-400',
                'primary-300',
                'primary-200',
                'primary-100',
                'primary-50',
            ],

            secondaryPink: [
                'secondary-pink-500',
                'secondary-pink-400',
                'secondary-pink-300',
                'secondary-pink-200',
                'secondary-pink-100',
                'secondary-pink-50',
            ],
            secondaryPurple: [
                'secondary-purple-500',
                'secondary-purple-400',
                'secondary-purple-300',
                'secondary-purple-200',
                'secondary-purple-100',
                'secondary-purple-50',
            ],
            secondaryTeal: [
                'secondary-teal-500',
                'secondary-teal-400',
                'secondary-teal-300',
                'secondary-teal-200',
                'secondary-teal-100',
                'secondary-teal-50',
            ],
            secondaryOrange: [
                'secondary-orange-500',
                'secondary-orange-400',
                'secondary-orange-300',
                'secondary-orange-200',
                'secondary-orange-100',
                'secondary-orange-50',
            ],
            secondaryBlue: [
                'secondary-blue-500',
                'secondary-blue-400',
                'secondary-blue-300',
                'secondary-blue-200',
                'secondary-blue-100',
                'secondary-blue-50',
            ],

            grayscale: [
                'grey-800',
                'grey-700',
                'grey-600',
                'grey-500',
                'grey-400',
                'grey-300',
                'grey-200',
                'grey-100',
                'grey-75',
                'grey-50',
                'grey',
                'white',
            ],

            successGreen: [
                'success-500',
                'success-400',
                'success-300',
                'success-200',
                'success-100',
                'success-50',
            ],
            warningYellow: [
                'warning-500',
                'warning-400',
                'warning-300',
                'warning-200',
                'warning-100',
                'warning-50',
            ],
            errorRed: [
                'error-500',
                'error-400',
                'error-300',
                'error-200',
                'error-100',
                'error-50',
            ],
            highlightBlue: [
                'highlight-500',
                'highlight-400',
                'highlight-300',
                'highlight-200',
                'highlight-100',
                'highlight-50',
            ],
        };
    },
};
</script>

<style lang="scss">
    .Colors {
        &__container {
            width: fit-content;
            margin: 25px auto;
            padding: 15px;
            background: lightgrey;
        }

        &__color-row {

        }

        &__color-block {
            display: inline-block;
            margin-right: 10px;
            width: 50px;
            height: 50px;

            // Primary
            &.primary-500 { background: $primary-500; }
            &.primary-400 { background: $primary-400; }
            &.primary-300 { background: $primary-300; }
            &.primary-200 { background: $primary-200; }
            &.primary-100 { background: $primary-100; }
            &.primary-50 { background: $primary-50; }

            // Secondary
            // Pink
            &.secondary-pink-500 { background: $secondary-pink-500 }
            &.secondary-pink-400 { background: $secondary-pink-400 }
            &.secondary-pink-300 { background: $secondary-pink-300 }
            &.secondary-pink-200 { background: $secondary-pink-200 }
            &.secondary-pink-100 { background: $secondary-pink-100 }
            &.secondary-pink-50 { background: $secondary-pink-50 }
            // Purple
            &.secondary-purple-500 { background: $secondary-purple-500 }
            &.secondary-purple-400 { background: $secondary-purple-400 }
            &.secondary-purple-300 { background: $secondary-purple-300 }
            &.secondary-purple-200 { background: $secondary-purple-200 }
            &.secondary-purple-100 { background: $secondary-purple-100 }
            &.secondary-purple-50 { background: $secondary-purple-50 }
            // Teal
            &.secondary-teal-500 { background: $secondary-teal-500 }
            &.secondary-teal-400 { background: $secondary-teal-400 }
            &.secondary-teal-300 { background: $secondary-teal-300 }
            &.secondary-teal-200 { background: $secondary-teal-200 }
            &.secondary-teal-100 { background: $secondary-teal-100 }
            &.secondary-teal-50 { background: $secondary-teal-50 }
            // Orange
            &.secondary-orange-500 { background: $secondary-orange-500 }
            &.secondary-orange-400 { background: $secondary-orange-400 }
            &.secondary-orange-300 { background: $secondary-orange-300 }
            &.secondary-orange-200 { background: $secondary-orange-200 }
            &.secondary-orange-100 { background: $secondary-orange-100 }
            &.secondary-orange-50 { background: $secondary-orange-50 }
            // Blue
            &.secondary-blue-500 { background: $secondary-blue-500 }
            &.secondary-blue-400 { background: $secondary-blue-400 }
            &.secondary-blue-300 { background: $secondary-blue-300 }
            &.secondary-blue-200 { background: $secondary-blue-200 }
            &.secondary-blue-100 { background: $secondary-blue-100 }
            &.secondary-blue-50 { background: $secondary-blue-50 }

            //Greyscale
            &.grey-800 { background: $grey-800 }
            &.grey-700 { background: $grey-700 }
            &.grey-600 { background: $grey-600 }
            &.grey-500 { background: $grey-500 }
            &.grey-400 { background: $grey-400 }
            &.grey-300 { background: $grey-300 }
            &.grey-200 { background: $grey-200 }
            &.grey-100 { background: $grey-100 }
            &.grey-75 { background: $grey-75 }
            &.grey-50 { background: $grey-50 }
            &.grey { background: $grey }
            &.white { background: $white }

            //Semantic
            //Success Green
            &.success-500 { background: $success-500 }
            &.success-400 { background: $success-400 }
            &.success-300 { background: $success-300 }
            &.success-200 { background: $success-200 }
            &.success-100 { background: $success-100 }
            &.success-50 { background: $success-50 }
            //Warning Yellow
            &.warning-500 { background: $warning-500 }
            &.warning-400 { background: $warning-400 }
            &.warning-300 { background: $warning-300 }
            &.warning-200 { background: $warning-200 }
            &.warning-100 { background: $warning-100 }
            &.warning-50 { background: $warning-50 }
            //Error Red
            &.error-500 { background: $error-500 }
            &.error-400 { background: $error-400 }
            &.error-300 { background: $error-300 }
            &.error-200 { background: $error-200 }
            &.error-100 { background: $error-100 }
            &.error-50 { background: $error-50 }
            //Highlight Blue
            &.highlight-500 { background: $highlight-500 }
            &.highlight-400 { background: $highlight-400 }
            &.highlight-300 { background: $highlight-300 }
            &.highlight-200 { background: $highlight-200 }
            &.highlight-100 { background: $highlight-100 }
            &.highlight-50 { background: $highlight-50 }
        }
    }
</style>
